/**
 *
 * Asynchronously loads the component for ManagePages
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ManagePages = lazyLoad(() => import('./index'));
